export default __webpack_public_path__ + "static/media/stage_03@2x.491f3b3e.png";